import React from 'react';
import { useTheme } from 'contexts/theme';
import styles from './loader.module.sass';

export default function Loader() {
  const { dark } = useTheme();
  return (
    <div className={dark ? styles['loader-dark'] : styles['loader-light']}>
      <span>Making Powerful Connections</span>
    </div>
  );
}
